// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : component registry react components
// =============================================================================
// ---Third-party imports
import React from 'react'
import {get, iterItems, isObject, isFunction} from 'ldash'

// ---Framework imports
import connect from 'uix/connect'

// ---Globals
export class Registry {
  constructor(registry) {
    this._reg = {
      components: {},
      // connect: if true, connect to redux store
      connect: false,
      // namespace: prefix with namespace in redux connect
      namespace: null,
      ...registry,
    }

    if (this._reg.connect) {
      this._connect(registry.components)
    }
  }

  // connect to redux store
  _connect = components => {
    iterItems(components, (name, comp) => {
      let ns_name = name
      if (this._reg.namespace) {
        ns_name = `${this._reg.namespace}/${name}`
      }
      // replace component with connected version
      if (isObject(comp)) {
        let {__render_f, ...descr} = comp
        if (isFunction(__render_f)) {
          this._reg.components[name] = connect(
            ns_name,
            descr,
            __render_f
          )
          return // done
        }
      }
      this._reg.components[name] = connect(
        ns_name,
        comp
      )
    })
  }

  // get a component by name, if not available we return null
  get = name => get(this._reg, `components.${name}`, null)
  // return created react element from component
  createElement = name => (this.get(name) ? React.createElement(this.get(name)) : `Missing ${name}`)

  // register more components
  register = components => {
    this._reg.components = {...this._reg.components, ...components}

    if (this._reg.connect) {
      this._connect(components)
    }
  }

  // access list of components directly
  get components() {
    return this._reg.components
  }
}
